import { useState } from "react";
import type { CalendarEvent } from "@/features/calendar/types";
import { useUpdateEvent } from "@/features/calendar/hooks/use-events";

export function useDragDrop() {
  const [draggedEvent, setDraggedEvent] = useState<CalendarEvent | null>(null);
  const [dragOverSlot, setDragOverSlot] = useState<{
    hour: number;
    minute: number;
    dayIndex: number;
  } | null>(null);
  const updateEventMutation = useUpdateEvent();

  const handleDragStart = (event: CalendarEvent) => {
    setDraggedEvent(event);
  };

  const handleDragOver = (dayIndex: number, hour: number, minute: number) => {
    setDragOverSlot({ dayIndex, hour, minute });
  };

  const handleDrop = (targetDay: Date, hour: number, minute: number) => {
    if (!draggedEvent) return;

    const eventStart = new Date(draggedEvent.start_time);
    const eventEnd = new Date(draggedEvent.end_time);
    const duration = eventEnd.getTime() - eventStart.getTime();

    // Create new start time with the target date and time
    const newStart = new Date(targetDay);
    newStart.setHours(hour, minute, 0, 0);
    const newEnd = new Date(newStart.getTime() + duration);

    // Update the event
    updateEventMutation.mutate({
      eventId: draggedEvent.id,
      data: {
        start_time: newStart.getTime(),
        end_time: newEnd.getTime(),
      },
    });

    setDraggedEvent(null);
    setDragOverSlot(null);
  };

  const handleDragEnd = () => {
    setDraggedEvent(null);
    setDragOverSlot(null);
  };

  return {
    draggedEvent,
    dragOverSlot,
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleDragEnd,
  };
}
